import { useRestPost, UseRestPostMutationOptions } from 'scbk-services';
import { APIS } from 'scbk-shared-module/constants';
import { UtlFncCfbRegisterComfyBankRequest } from '../types/api/utlFncCfbRegisterComfyBank';

/**
 * 편한뱅킹 적재
 * @param mutationOptions
 * @returns
 */
export function useUtlFncCfbRegisterComfyBank(
  mutationOptions?: UseRestPostMutationOptions<UtlFncCfbRegisterComfyBankRequest, null>,
) {
  return useRestPost<UtlFncCfbRegisterComfyBankRequest, null>(
    {
      endpoint: APIS.utilities.functions.comfyBank.registerComfyBank,
    },
    mutationOptions,
  );
}
